<template>
    <ContainerContent
        class="mb-16"
        max-class="max-w-sm-ceil"
        outer-container
    >
        <v-row>
            <v-col>
                <h1 class="page-title">Frequently Asked Questions</h1>
            </v-col>
        </v-row>
        <v-row>
            <v-col>
                <FaqList
                    :type="['general']"
                    class="d-flex flex-column"
                ></FaqList>
            </v-col>
        </v-row>
    </ContainerContent>
</template>

<script lang="ts" setup>
    import ContainerContent from '~/components/ContainerContent/ContainerContent.vue';
    import FaqList from '~/components/FaqList/FaqList.vue';

    definePageMeta({
        scrollToTop: true
    });

    const $config = useRuntimeConfig();
    const brandTitle = $config.public.brand.title;

    useHead({
        title: `Frequently Asked Questions | ${brandTitle}`,
        meta: [
            {
                name: 'description',
                content: 'The Best Trust StringKing'
            }
        ]
    });
</script>
